<div class="border-b border-zinc-200 px-5 pb-4 dark:border-white/8">
  <div class="flex flex-col gap-4 xl:flex-row xl:items-center xl:justify-between">
    <nav aria-label="Stats period presets" class="flex flex-wrap items-center gap-2">
      <button
        type="button"
        class="rounded-full border px-4 py-2 text-sm font-medium transition-colors"
        [class]="getPresetButtonClass('this-week')"
        [attr.aria-current]="preset() === 'this-week' ? 'page' : null"
        (click)="selectPreset('this-week')"
      >
        This week
      </button>
      <button
        type="button"
        class="rounded-full border px-4 py-2 text-sm font-medium transition-colors"
        [class]="getPresetButtonClass('this-month')"
        [attr.aria-current]="preset() === 'this-month' ? 'page' : null"
        (click)="selectPreset('this-month')"
      >
        This month
      </button>
    </nav>

    <div class="flex flex-col gap-4 sm:flex-row sm:items-end sm:gap-4">
      <label class="flex min-w-[10rem] flex-col gap-1">
        <span class="text-xs font-semibold uppercase tracking-wide text-zinc-500">From</span>
        <input
          type="date"
          class="rounded-lg border border-zinc-200 bg-white px-3 py-2 text-sm text-zinc-900 [color-scheme:light] dark:border-white/10 dark:bg-[#12121c] dark:text-white dark:[color-scheme:dark]"
          [value]="customStartDate()"
          [attr.max]="startDateMax()"
          (change)="onCustomStartInput($event)"
        />
      </label>
      <label class="flex min-w-[10rem] flex-col gap-1">
        <span class="text-xs font-semibold uppercase tracking-wide text-zinc-500">To</span>
        <input
          type="date"
          class="rounded-lg border border-zinc-200 bg-white px-3 py-2 text-sm text-zinc-900 [color-scheme:light] dark:border-white/10 dark:bg-[#12121c] dark:text-white dark:[color-scheme:dark]"
          [value]="customEndDate()"
          [attr.min]="customStartDate() || null"
          [attr.max]="latestSelectableDate()"
          (change)="onCustomEndInput($event)"
        />
      </label>
      <ng-content />
    </div>
  </div>
</div>
